import { render, staticRenderFns } from "./AddPurchaseInvoice.vue?vue&type=template&id=60719c9b"
import script from "./AddPurchaseInvoice.vue?vue&type=script&lang=ts"
export * from "./AddPurchaseInvoice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports